import { RenewVisaHistoryListPage } from "@/features/renew-visa/pages/RenewVisaHistoryList";

const RenewVisaHistoryList = () => {
  return <RenewVisaHistoryListPage />;
};

export default RenewVisaHistoryList;
